import { select } from 'redux-saga/effects'

export const selectApiKey = () => select((state) => state.auth.api_key)
export const selectUserId = () => select((state) => state.auth.sub)
export const selectPanelEnv = () => select((state) => state.auth.panelEnv)
